import * as React from 'react'

import { Form } from 'factorial-form'
import { ContractFlowCustomFieldFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import DayPicker from 'modules/core/components/Inputs/DayPicker'
import i18n from 'modules/core/lib/i18n'

import { getCustomFieldKey } from 'modules/contracts/lib/customFields'

interface Props {
  form: Form
  field: ContractFlowCustomFieldFragment
}

const DateCustomField = ({ form, field }: Props) => {
  return (
    <DayPicker
      mandatory={field.required ?? false}
      withNull={!field.required}
      label={field.labelText}
      field={form.get(getCustomFieldKey(field))}
      placeholder={i18n.t('employee_form.contract_select_date')}
    />
  )
}

export default observer(DateCustomField)
